"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _ApiClient = _interopRequireDefault(require("../ApiClient"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
//import InfoOutputsValueExample from './InfoOutputsValueExample';
/**
 * The InfoOutputsValue model module.
 * @module model/InfoOutputsValue
 * @version 1.0.0
 */
var InfoOutputsValue = /*#__PURE__*/function () {
  /**
   * Constructs a new <code>InfoOutputsValue</code>.
   * @alias module:model/InfoOutputsValue
   */
  function InfoOutputsValue() {
    _classCallCheck(this, InfoOutputsValue);
    InfoOutputsValue.initialize(this);
  }

  /**
   * Initializes the fields of this object.
   * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
   * Only for internal use.
   */
  _createClass(InfoOutputsValue, null, [{
    key: "initialize",
    value: function initialize(obj) {}

    /**
     * Constructs a <code>InfoOutputsValue</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/InfoOutputsValue} obj Optional instance to populate.
     * @return {module:model/InfoOutputsValue} The populated <code>InfoOutputsValue</code> instance.
     */
  }, {
    key: "constructFromObject",
    value: function constructFromObject(data, obj) {
      if (data) {
        obj = obj || new InfoOutputsValue();
        if (data.hasOwnProperty('description')) {
          obj['description'] = _ApiClient.default.convertToType(data['description'], 'String');
        }
        if (data.hasOwnProperty('label')) {
          obj['label'] = _ApiClient.default.convertToType(data['label'], 'String');
        }
        if (data.hasOwnProperty('type')) {
          obj['type'] = _ApiClient.default.convertToType(data['type'], 'String');
        }
        if (data.hasOwnProperty('range')) {
          obj['range'] = _ApiClient.default.convertToType(data['range'], ['Number']);
        }
        if (data.hasOwnProperty('options')) {
          obj['options'] = _ApiClient.default.convertToType(data['options'], ['String']);
        }
        if (data.hasOwnProperty('properties')) {
          obj['properties'] = _ApiClient.default.convertToType(data['properties'], ['String']);
        }
        if (data.hasOwnProperty('example')) {
          // JM Lord: Current version of the generator does not work when type is "oneOf" in OpenAPI spec.
          // We want the default convertToType clause to execute.
          obj['example'] = _ApiClient.default.convertToType(data['example'], 'depends on type');
        }
      }
      return obj;
    }

    /**
     * Validates the JSON data with respect to <code>InfoOutputsValue</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>InfoOutputsValue</code>.
     */
  }, {
    key: "validateJSON",
    value: function validateJSON(data) {
      // ensure the json data is a string
      if (data['description'] && !(typeof data['description'] === 'string' || data['description'] instanceof String)) {
        throw new Error("Expected the field `description` to be a primitive type in the JSON string but got " + data['description']);
      }
      // ensure the json data is a string
      if (data['label'] && !(typeof data['label'] === 'string' || data['label'] instanceof String)) {
        throw new Error("Expected the field `label` to be a primitive type in the JSON string but got " + data['label']);
      }
      // ensure the json data is a string
      if (data['type'] && !(typeof data['type'] === 'string' || data['type'] instanceof String)) {
        throw new Error("Expected the field `type` to be a primitive type in the JSON string but got " + data['type']);
      }
      // ensure the json data is an array
      if (!Array.isArray(data['range'])) {
        throw new Error("Expected the field `range` to be an array in the JSON data but got " + data['range']);
      }
      // ensure the json data is an array
      if (!Array.isArray(data['options'])) {
        throw new Error("Expected the field `options` to be an array in the JSON data but got " + data['options']);
      }
      // ensure the json data is an array
      if (!Array.isArray(data['properties'])) {
        throw new Error("Expected the field `properties` to be an array in the JSON data but got " + data['properties']);
      }
      // validate the optional field `example`
      if (data['example']) {// data not null
        // JM Lord: Current version of the generator does not work when type is "oneOf" in OpenAPI spec.
        //InfoOutputsValueExample.validateJSON(data['example']);
      }
      return true;
    }
  }]);
  return InfoOutputsValue;
}();
/**
 * @member {String} description
 */
InfoOutputsValue.prototype['description'] = undefined;

/**
 * @member {String} label
 */
InfoOutputsValue.prototype['label'] = undefined;

/**
 * @member {String} type
 */
InfoOutputsValue.prototype['type'] = undefined;

/**
 * @member {Array.<Number>} range
 */
InfoOutputsValue.prototype['range'] = undefined;

/**
 * @member {Array.<String>} options
 */
InfoOutputsValue.prototype['options'] = undefined;

/**
 * @member {Array.<String>} properties
 */
InfoOutputsValue.prototype['properties'] = undefined;

/**
 * @member {module:model/InfoOutputsValueExample} example
 */
InfoOutputsValue.prototype['example'] = undefined;
var _default = InfoOutputsValue;
exports.default = _default;